<template>
  <div class="notranslate xs:w-[450px] flex w-[350px] flex-col rounded-t-md" translate="no">
    <div v-for="item in countries" :key="`marketplace-${item}`" class="flex h-[62px] items-center justify-between border-b first:rounded-t-md">
      <div class="pl-4">
        <Icon :name="item" :width="14" :height="14" />
      </div>
      <label :for="`country-item-${item}`" class="v3-body-regular-400-line-height-auto radio-label notranslate flex-1 py-5 pl-2" translate="no">{{ item }}</label>
      <div class="shrink-0 py-5 pr-4">
        <RadioButton
          v-model="selected"
          :input-id="`country-item-${item}`"
          name="pizza"
          :value="item"
        />
      </div>
    </div>
    <div class="flex items-center gap-2 px-4 py-5">
      <Button
        class="w-full"
        label="Cancel"
        severity="secondary"
        outlined
        @click="closeDialog"
      />
      <Button class="w-full" label="Select" @click="updateSelected" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Button from 'primevue/button';
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions';
import RadioButton from 'primevue/radiobutton';
import type { Ref } from 'vue';
import { inject, onMounted, ref } from 'vue';

import Icon from '@/common/components/atoms/Icon';
import type { CountryCode } from '@/types/country';

type DialogRef = Ref<DynamicDialogInstance>;

const selected = ref<CountryCode>();
const countries = ref<CountryCode[]>([]);

const dialogRef = inject<DialogRef>('dialogRef');

onMounted(() => {
  selected.value = dialogRef.value?.data.selectedCountry;
  countries.value = dialogRef.value?.data.countries;
});

const closeDialog = () => {
  dialogRef.value.close({
    action: 'cancel',
  });
};

const updateSelected = () => {
  dialogRef.value.close({
    action: 'select',
    selectedCountry: selected.value,
  });
};
</script>

<style lang="scss" scoped>
.radio-label {
    color: var(--next-text-on-light-primary, #69707A);
}
</style>
